<template>
  <vue-perfect-scrollbar class="absolute notification__container">
    <div class="header p-4">
      <h3
        class="text-left text-2xl text-black font-bold notification__text pb-4 pt-2"
      >
        Notifications
      </h3>
      <div class="flex items-center justify-between types">
        <span
          class="cursor-pointer notification__inactive webkit-width w-full"
          :class="{
            notification__active: notificationType === 'learning-actions',
          }"
          id="learning-actions"
          @click="notificationType = 'learning-actions'"
        >
          <h4 class="ml-2 mr-1 text-lg mb-1">Learning Actions</h4>
        </span>
        <span
          v-if="appSubscriptions.journey && galaQuests"
          class="cursor-pointer notification__inactive webkit-width w-full"
          :class="{
            notification__active: notificationType === 'journey-quests',
          }"
          id="journey-quests"
          @click="notificationType = 'journey-quests'"
        >
          <h4 class="mx-1 text-lg mb-1">Journey Quests</h4>
        </span>
        <span
          v-if="appSubscriptions.coach"
          class="cursor-pointer notification__inactive webkit-width w-full"
          :class="{ notification__active: notificationType === 'growth-plans' }"
          id="growth-plans"
          @click="notificationType = 'growth-plans'"
        >
          <h4 class="mr-2 ml-2 text-lg mb-1">Growth Plans</h4>
        </span>
      </div>
    </div>

    <div v-if="loadingSkeleton" class="px-1 md:px-4 pb-2">
      <vs-row class="px-3 pb-3">
        <vs-row v-for="i in 5" :key="i" class="p-8 skeleton rounded-lg my-2" />
      </vs-row>
    </div>

    <div v-if="!loadingSkeleton" class="px-2 md:px-4 pb-1">
      <div
        class="flex flex-col"
        v-if="notificationType === 'learning-actions' && appSubscriptions.alex"
      >
        <!-- validation notification -->
        <div v-if="items && items.length > 0 && !loadingSkeleton">
          <div
            v-for="(item, index) in items"
            :key="item.itemId"
            class="flex items-center justify-between w-full border px-1 md:px-4 py-4 mb-4"
            :class="{
              hidden: !(
                (item.status === 'done' ||
                  item.feedLibraryItemStatus === 'done') &&
                item.libraryItemValidationData
              ),
            }"
          >
            <div class="flex w-full">
              <div class="w-32 h-24 overflow-hidden rounded-lg">
                <img
                  class="w-full h-full object-contain"
                  :src="item.imageUrl"
                  @error="randomFeedImage"
                />
              </div>
              <div class="flex flex-col mx-2 w-full justify-between">
                <h5 class="text-left">
                  {{ item.title | title }}
                </h5>
                <div class="flex items-center mt-2 justify-between">
                  <div class="flex items-center">
                    <!-- gold-coin -->
                    <div
                      v-if="
                        item.libraryItemValidationData &&
                        item.libraryItemValidationData.tokens &&
                        getTokenValue(
                          item.libraryItemValidationData.tokens,
                          6
                        ) > 0
                      "
                      class="flex items-end px-2 py-1 mx-2"
                      :id="activeIndex === index ? 'reward-gold' : ''"
                    >
                      <img
                        class="w-8 h-8"
                        src="@/assets/images/icons/tokens/gold-coin.svg"
                        alt=""
                      />
                      <h6 class="text-sm">
                        {{
                          getTokenValue(
                            item.libraryItemValidationData.tokens,
                            6
                          )
                        }}
                      </h6>
                    </div>
                    <!-- xp -->
                    <div
                      v-if="
                        item.libraryItemValidationData &&
                        item.libraryItemValidationData.tokens
                      "
                      class="flex items-end px-2 py-1 mx-2"
                      :id="activeIndex === index ? 'reward-xp' : ''"
                    >
                      <img
                        class="w-8 h-8"
                        src="@/assets/images/icons/tokens/xp.svg"
                        alt=""
                      />

                      <h6 class="text-sm">
                        {{
                          getTokenValue(
                            item.libraryItemValidationData.tokens,
                            0
                          )
                        }}
                      </h6>
                    </div>
                    <!-- knowledge token -->
                    <div
                      v-if="item.kt"
                      class="token-box flex items-center justify-center p-2"
                    >
                      <img
                        class="w-8 h-8"
                        src="@/assets/images/icons/tokens/kt.svg"
                        alt=""
                      />
                      <h6 class="text-xl">{{ item.kt }}</h6>
                    </div>
                  </div>
                  {{ item }}
                  <div
                    v-if="item.reviewStatus"
                    @click="claimReward(item, index)"
                    class="btn-claim text-xl font-medium rounded-lg py-2 px-4 cursor-pointer ml-2"
                  >
                    {{ item.tokenClaimed ? "Claimed" : "Claim" }}
                  </div>
                  <div
                    v-else
                    @click="validateItem(item)"
                    class="text-black ml-2 btn-validate text-lg font-semibold rounded-lg py-2 px-4 cursor-pointer"
                  >
                    Validate
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-center flex-col mt-4 md:mt-8"
          v-if="!loadingSkeleton && items.length === 0"
        >
          <div class="">
            <img
              class="h-64"
              src="@/assets/images/user-dashboard/no_msg.svg"
              alt="No Notification"
            />
          </div>
          <h4 class="ml-6 mt-2">You've got no message</h4>
        </div>
      </div>

      <div
        v-if="notificationType === 'journey-quests' && appSubscriptions.journey"
      >
        <div class="progress__container mt mb-4">
          <div class="progress__container__info">
            <img src="@/assets/images/icons/progress-coin.svg" />
            <span v-if="journeyIndex === 1"> {{ completedSteps * 100 }}</span>
            <span v-if="journeyIndex === 2">{{ completedSteps * 200 }}</span>
          </div>
          <div class="progress__container__bar">
            <vs-tooltip
              v-for="(step, i) in activeStep"
              :text="getStepName(step.id)"
              :key="i"
              class="flex justify-center"
              :class="i % 2 === 0 ? 'odd' : 'even'"
              :position="i % 2 === 0 ? 'top' : 'bottom'"
            >
              <a :href="step.url" target="_blank">
                <img
                  :key="i"
                  :class="i % 2 === 0 ? 'odd' : 'even'"
                  :src="
                    require(`@/assets/images/icons/chest-${
                      i % 2 === 0 ? 'top' : 'bottom'
                    }.svg`)
                  "
                  :alt="step.id"
                />
              </a>
            </vs-tooltip>

            <progress
              v-if="activeStep"
              class="progress"
              max="100"
              :value="getJourneyProgress(activeStep)"
            ></progress>
          </div>
        </div>
        <vs-row
          class="journey__notification__card cursor-pointer p-4 mb-3"
          v-for="(journeyQuest, i) in journeyQuests"
          :key="i"
          :class="`q${journeyIndex}` === i ? '' : 'opacity-50'"
        >
          <div class="w-full" @click="activeSelectedStep(journeyQuest, i)">
            <h4 class="flex text-white text-left font-semibold mb-4">
              Gala Quest {{ i === "q1" ? 1 : 2 }}
              <a class="ml-3" :href="journeyQuest.steps[1].url" target="_blank">
                <img
                  src="@/assets/images/icons/arrow-right-circle-white.svg"
                  alt=""
                  class="w-6 h-6"
                />
              </a>
            </h4>
            <progress
              class="progress w-full"
              max="100"
              :value="getJourneyProgress(journeyQuest.steps)"
            />

            <!-- <div class="flex items-start my-3">
              <img src="@/assets/images/icons/clock.svg" alt="Clock" />
              <h5 class="text-left ml-2 text-white">
                Activated after Quest 1. Went live 4 Days 20 hours ago
              </h5>
            </div> -->

            <div
              class="flex items-start mt-8 w-full items-center justify-between"
            >
              <h5 class="text-left text-white w-1/2">
                Activated since <br />
                <span class="font-semibold">
                  {{ getGoalActiveDate(i) }}
                  {{ i === "q1" ? questQ1 : questQ2 }}
                </span>
              </h5>
              <div class="reward__container flex py-2 px-1">
                <!-- gold-coin -->
                <div
                  class="token-box flex items-center justify-center py-1 px-2 mx-1"
                >
                  <img
                    class="w-6 h-6"
                    src="@/assets/images/icons/tokens/gold-coin.svg"
                    alt=""
                  />
                  <h6 class="ml-1 text-xl" v-if="i === 'q1'">500</h6>
                  <h6 class="ml-1 text-xl" v-if="i === 'q2'">500</h6>
                </div>
                <!-- xp -->
                <div
                  class="token-box flex items-center justify-center p-2 mx-1"
                >
                  <img
                    class="w-6 h-6"
                    src="@/assets/images/icons/tokens/xp.svg"
                    alt=""
                  />

                  <h6 class="ml-1 text-xl" v-if="i === 'q1'">5000</h6>
                  <h6 class="ml-1 text-xl" v-if="i === 'q2'">5000</h6>
                </div>
                <!-- key -->
                <!-- <div
                  class="token-box flex items-center justify-center p-2 mx-1"
                >
                  <img
                    class="w-6 h-6"
                    src="@/assets/images/icons/tokens/key.svg"
                    alt=""
                  />

                  <h6 class="ml-1 text-xl">5</h6>
                </div> -->
              </div>
            </div>
          </div>
        </vs-row>
      </div>

      <div v-if="notificationType === 'growth-plans' && appSubscriptions.coach">
        <vs-row
          v-if="
            coachUserData &&
            coachUserData.data &&
            Array.isArray(coachUserData.data) &&
            receivedCoachData
          "
        >
          <vs-table ref="table" v-model="selected" :data="coachUserData.data">
            <template slot="thead">
              <vs-th sort-key="id">{{ $t("coach.tblHeadings.th2") }}</vs-th>
              <vs-th class="flex justify-center" sort-key="name">{{
                $t("coach.tblHeadings.th8")
              }}</vs-th>
              <vs-th sort-key="journey">{{
                $t("coach.tblHeadings.th21")
              }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody v-if="data">
                <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in coachUserData.data"
                >
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.userData[0].firstName }}
                    </p>
                  </vs-td>
                  <vs-td class="flex justify-center">
                    <feather-icon
                      v-if="tr.motivationSurvey === 1"
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t3_1')"
                      :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                    />
                    <feather-icon
                      v-else-if="tr.motivationSurvey === 2"
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t3_2')"
                      :svgClasses="['fill-current nt h-4 w-4', 'text-warning']"
                    />
                    <feather-icon
                      v-else
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t3_3')"
                      :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                    />
                    <feather-icon
                      v-if="tr.coachingSurvey === 1"
                      class="ml-2"
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t4_1')"
                      :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                    />
                    <feather-icon
                      v-else-if="tr.coachingSurvey === 2"
                      class="ml-2"
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t4_2')"
                      :svgClasses="['fill-current h-4 w-4', 'text-warning']"
                    />
                    <feather-icon
                      v-else
                      class="ml-2"
                      icon="CircleIcon"
                      :title="$t('coach.playerJourney.t4_3')"
                      :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                    />
                  </vs-td>

                  <vs-td>
                    <vs-tooltip
                      text="Development"
                      position="bottom"
                      class="flex justify-center"
                    >
                      <feather-icon
                        @click="toCoach"
                        class="p-1 rounded-md add-btn cursor-pointer text-center w-8 h-8"
                        icon="ArrowRightIcon"
                      />
                    </vs-tooltip>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-row>

        <vs-row v-else-if="growthPlan.complete && growthPlan.inProgress">
          <vs-row v-if="growthPlan.inProgress.length > 0">
            <h4 class="mb-2 font-semibold text-xl text-black">In Progress</h4>
            <vs-col
              class="mb-3"
              v-for="plan in growthPlan.inProgress"
              :key="plan.id"
            >
              <div class="w-full flex items-center">
                <vs-avatar
                  class=""
                  size="40px"
                  :src="getCompentencyData(plan.competencyId).icon"
                />
                <h4>{{ getCompentencyData(plan.competencyId).comp }}</h4>
              </div>
            </vs-col>
          </vs-row>

          <vs-row v-if="growthPlan.complete.length > 0">
            <h4 class="mb-2 font-semibold text-xl text-black">In Progress</h4>
            <vs-col
              class="mb-3"
              v-for="plan in growthPlan.complete"
              :key="plan.id"
            >
              <div class="w-full flex items-center">
                <vs-avatar
                  class=""
                  size="40px"
                  :src="getCompentencyData(plan.competencyId).icon"
                />
                <h4>{{ getCompentencyData(plan.competencyId).comp }}</h4>
              </div>
            </vs-col>
          </vs-row>
        </vs-row>

        <vs-row v-else-if="receivedCoachData">
          <vs-col class="flex items-center">
            <img
              class="w-1/5 lg:w-1/3"
              src="@/assets/images/user-dashboard/no-quest.svg"
              alt="no quest"
            />
            <h5 class="my-4">No growth plan active !</h5>
          </vs-col>
        </vs-row>
      </div>
    </div>

    <div
      @click="claimAllRewards()"
      v-if="
        notificationType === 'learning-actions' &&
        !loadingSkeleton &&
        claimAllBtn
      "
      class="sticky bottom-0 claim-all-btn p-4 flex justify-end"
    >
      <div
        class="w-1/2 btn-claim-all text-lg font-medium rounded-lg py-2 px-4 cursor-pointer"
      >
        Read and Claim All
      </div>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import appSteps from "@/assets/data/app-flow";

export default {
  data() {
    return {
      notificationType: "learning-actions",
      mergedItems: [],
      items: [],
      loadingSkeleton: true,
      coachUserData: {},
      growthPlan: [],
      selected: [],
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      receivedCoachData: false,
      claimAllBtn: false,
      CCD: this.$t("coach.addNewSkill.data"),
      learningActionItems: false,
      activeIndex: null,
      journeyQuests: {},
      activeStep: {},
      completedSteps: 0,
      journeyIndex: 1,
      galaQuests: false,
      questQ1: "",
      questQ2: "",
      appSteps,
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    userOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    notificationPanelPopup() {
      return this.$store.state.modals.notificationPanelPopup;
    },
    appSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
    journeySteps() {
      return appSteps.flow.journey.steps;
    },
  },
  watch: {
    notificationType: {
      immediate: true,
      handler(newVal) {
        if (newVal === "learning-actions") {
          this.fetchUserInterestedItems();
        } else if (newVal === "journey-quests") {
          this.getJourneyQuests();
        } else if (newVal === "growth-plans") {
          this.fetchGrowthPlans();
        }
      },
    },
    items: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let claimItems = [];
          for (let i = 0; i < newVal.length; i++) {
            if (
              (newVal[i].reviewStatus && !newVal[i].tokenClaimed) ||
              (newVal[i].libraryItemValidationData &&
                (newVal[i].status === "done" ||
                  newVal[i].feedLibraryItemStatus === "done"))
            ) {
              this.learningActionItems = true;
            }

            if (newVal[i].reviewStatus && !newVal[i].tokenClaimed) {
              claimItems.push(newVal[i]);
            }
            this.claimAllBtn = claimItems.length > 0 ? true : false;
          }
        }
      },
    },
    notificationPanelPopup: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.notificationType === "learning-actions") {
            this.fetchUserInterestedItems();
          }
        }
      },
    },
    userOrganizations: {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          this.galaQuests =
            newVal[i].organizationData.slug === "gala" ? true : false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    mergeArrays(array1, array2) {
      const merged = [];
      const idSet = new Set();
      for (const item of array1) {
        merged.push(item);
        idSet.add(item.feedItemId);
      }
      for (const item of array2) {
        if (idSet.has(item.itemId)) {
          const existingItem = merged.find(
            (el) => el.feedItemId === item.itemId
          );
          Object.assign(existingItem, item);
        } else {
          merged.push(item);
          idSet.add(item.itemId);
        }
      }
      this.mergedItems = [];
      for (let i = 0; i < merged.length; i++) {
        if (
          merged[i].libraryItemValidationData &&
          (merged[i].status === "done" ||
            merged[i].feedLibraryItemStatus === "done" ||
            merged[i].feedItemUserValidationStatus)
        ) {
          this.mergedItems.push(merged[i]);
        }
      }
    },
    fetchUserInterestedItems() {
      if (this.notificationType === "learning-actions") {
        this.loadingSkeleton = true;
        this.$store
          .dispatch("alex/getRedirectItemsCount", {
            // gtbrddOrganizationId: this.userOrganizations[i].organizationId,
            gtbrddUserId: this.userData._id,
            source: ["LIBRARY"],
            // source: [],
          })
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              let itemIds = [];
              let array1 = res.data;
              for (let element of res.data) {
                if (!itemIds.includes(element.feedItemId)) {
                  itemIds.push(element.feedItemId);
                }
              }

              this.$store
                .dispatch("feed/fetchBulkItemDetails", {
                  itemId: itemIds,
                  getboardedId: this.userData._id,
                })
                .then((res) => {
                  let array2 = res;
                  this.mergeArrays(array1, array2);
                })
                .catch((err) => {});

              if (res.data.length > 0) {
                let altfItems = [];
                for (let a = 0; a < res.data.length; a++) {
                  if (res.data[a].feedItemId.includes("altf")) {
                    const payload = {
                      orgId: "6512fc951aa789001abd5ed4",
                      itemId: res.data[a].feedItemId,
                      userId: this.userData._id,
                    };
                    this.$store
                      .dispatch("alex/fetchCustomLibraryItem", payload)
                      .then((res) => {
                        if (res.data) {
                          altfItems.push(res.data);
                          this.mergeArrays(array1, altfItems);
                        }
                      })
                      .catch((err) => {
                        // console.log(err);
                      });
                  }
                }
              }
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.loadingSkeleton = false;
            this.items = this.mergedItems;
          });
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.userOrganization.organizationId
      }&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) {
        window.open(link, "_blank");
      }
    },
    validateItem(item) {
      event.stopPropagation();
      this.$store.commit("modals/OPEN_CHAT_BOT_POPUP", true);
      this.$store.commit("users/SET_VALIDATE_ITEM", true);
      this.$store.commit("users/SET_ITEM_TO_VALIDATE", item);
      this.$store.commit("modals/OPEN_NOTIFICATION_POPUP", false);
    },
    fetchGrowthPlans() {
      // this.loadingSkeleton = true;
      this.receivedCoachData = false;
      for (let i = 0; i < this.userOrganizations.length; i++) {
        this.$store
          .dispatch("users/getGrowthPlans", {
            userId: this.userData._id,
            orgId: this.userOrganizations[i].organizationId,
          })
          .then((res) => {
            if (res && res.data) {
              this.growthPlan = res.data;
            }

            if (res.code === "USER_IS_COACH") {
              return this.getCoachUserData();
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.receivedCoachData = true;
            // this.loadingSkeleton = false;
          });
      }
    },
    getJourneyQuests() {
      this.loadingSkeleton = true;
      this.$store
        .dispatch("users/fetchJourneyQuests", {
          gtbrddUserId: this.userData._id,
        })
        .then((res) => {
          this.journeyQuests = res.data;
          for (let key in res.data) {
            this.activeSelectedStep(res.data[key], key);
            break;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loadingSkeleton = false;
        });
    },
    getCoachUserData() {
      this.$store
        .dispatch("coach/getCoachUserData", this.userData._id)
        .then((res) => {
          this.coachUserData = res;
        })
        .catch((err) => {})
        .finally(() => {
          this.receivedCoachData = true;
          // this.loadingSkeleton = false;
        });
    },
    toCoach() {
      let user = this.userData.email.slice(0, this.userData.email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
    claimReward(item, index) {
      event.stopPropagation();

      if (!item.tokenClaimed) {
        const payload = {
          gtbrddOrganizationId:
            item.libraryItemValidationData.gtbrddOrganizationId,
          gtbrddUserId: this.userData._id,
          libraryItemId: item.itemId,
        };
        this.$store
          .dispatch("alex/claimRewards", payload)
          .then((res) => {
            if (res && res.data && res.data._id) {
              for (let i = 0; i < this.items.length; i++) {
                let itemsClaimedCount = 0;
                let itemsToBeClaimedCount = 0;
                if (this.items[i].tokenClaimed) {
                  itemsClaimedCount = itemsClaimedCount + 1;
                }

                if (this.items[i].reviewStatus) {
                  itemsToBeClaimedCount = itemsToBeClaimedCount + 1;
                }

                if (itemsClaimedCount === itemsToBeClaimedCount) {
                  this.claimAllBtn = false;
                }
              }

              this.activeIndex = index;
              this.$store.commit(
                "users/UPDATE_USER_TOKENS",
                item.libraryItemValidationData.tokens
              );
              setTimeout(() => {
                const ipGold = document
                  .getElementById("reward-gold")
                  .getBoundingClientRect();
                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_GOLD", {
                  top: ipGold.top,
                  bottom: ipGold.bottom,
                  left: ipGold.left,
                  right: ipGold.right,
                });

                const ipXp = document
                  .getElementById("reward-xp")
                  .getBoundingClientRect();

                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_XP", {
                  top: ipXp.top,
                  bottom: ipXp.bottom,
                  left: ipXp.left,
                  right: ipXp.right,
                });
                this.$store.commit("animation/SET_ANIMATION_STATUS", true);
              }, 50);
              this.items[index].tokenClaimed = true;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    claimAllRewards() {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].reviewStatus) {
          this.claimReward(this.items[i], i);
        }
      }
    },
    getCompentencyData(id) {
      const characteristicId = id.split("-")[0];
      const competencyId = id.split("-")[1];
      const competencies = this.CCD[characteristicId].competencies;
      return competencies[competencyId];
    },
    getTokenValue(tokens, key) {
      if (tokens) {
        let token = tokens.find((token) => token.key === key);
        return token ? token.value : 0;
      }
    },
    getJourneyProgress(steps) {
      let totalSteps = steps.length;
      let completedSteps = 0;
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      return (100 * completedSteps) / totalSteps;
    },
    activeSelectedStep(journeyQuest, i) {
      this.activeStep = journeyQuest.steps;
      let completedSteps = 0;
      for (let i = 0; i < this.activeStep.length; i++) {
        if (this.activeStep[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      this.completedSteps = completedSteps;
      this.journeyIndex = i === "q1" ? 1 : 2;
    },
    getGoalActiveDate(quest) {
      let boardId =
        quest === "q1"
          ? "63f7ac7c99ee08001de8c9b0"
          : "64f48a69c433ae00195dbeb0";
      this.$store
        .dispatch("boards/fetchCurrentBoardUserDetails", {
          userId: this.userData._id,
          boardId: boardId,
        })
        .then((res) => {
          if (res && res.data) {
            const timestamp = new Date(res.data[0].createdAt);
            const day = timestamp.getDate();
            const monthNames = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            const month = monthNames[timestamp.getMonth()];
            const year = timestamp.getFullYear();
            const formattedDate = `${day} ${month} ${year}`;
            if (quest === "q1") {
              this.questQ1 = formattedDate;
            } else if (quest === "q2") {
              this.questQ2 = formattedDate;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getStepName(step) {
    //   console.log("jj", step, this.journeySteps);
    //   let stepName = this.journeySteps.find((step) => {
    //     console.log(step, step.id);
    //     step.id === step;
    //   });
    //   console.log("eeee", stepName ? stepName.title : step);
    // },
    getStepName(stepId) {
      let step = this.journeySteps.find((step) => step.id === stepId);
      return step ? step.title : stepId;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  &__container {
    border-radius: 1.25rem;
    box-shadow: 0px 40px 40px 0px rgba(0, 0, 0, 0.25);
    background: #fff;
    height: 35rem;
    width: 30rem;
    z-index: 10;
    right: 0;

    .header {
      position: sticky;
      top: 0rem;
      z-index: 10;
      background: #fff;

      .types {
        margin: 0 -1em;
      }
    }

    .token-box {
      border-radius: 0.5rem;
      // background: #fff;
      background: #f2f4f7;
      border: 1px solid #d0d5dd;

      // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) inset,
      //   0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }

    .btn {
      &-claim {
        background: #25cc9a1a;
        color: #25cc9a;

        &-all {
          background: #f2f4f7;
          color: #98a2b3;
        }
      }

      &-validate {
        background: #f8c62c;
        color: #fff;
      }
    }

    .claim-all-btn {
      background: #fff;
    }

    .heading {
      &-gray {
        color: #808080 !important;
      }
    }

    .border {
      border: 2px solid #efefef;
    }
  }

  &__active {
    border-bottom: 5px solid #25cc9a !important;
  }

  &__inactive {
    border-bottom: 2px solid #f3f3f3;
  }
}

.journey__notification__card {
  border-radius: 0.75rem;
  background: #7a5af8;

  .reward__container {
    border-radius: 0.375rem;
    background: rgba(255, 255, 255, 0.5);
  }

  .progress {
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 10px;
    border: 2px solid #fff;
    height: 15px;
    background-color: #fff;
    text-align: left;
  }

  /* For Chrome or Safari */
  progress::-webkit-progress-bar {
    background-color: #ffffff;
    border-radius: 10px;
  }

  progress::-webkit-progress-value {
    background-color: #25cc9a !important;
    border-radius: 10px;
    place-self: start;
  }

  /* For Firefox */

  progress::-moz-progress-bar {
    background-color: #25cc9a !important;
    border-radius: 10px;
  }
}

$bg: #fba62742;
$color: #fba727;

.icon-bg {
  background-color: $bg;
}

.skills-btn {
  color: $color !important;
  background: $bg;
}

.vx-card ::v-deep .vx-card__body {
  padding: 0;
}

.opacity {
  opacity: 0.075;
}

.webkit-width {
  width: -webkit-fill-available;
}

.circle ::v-deep .percent-text {
  font-size: 15px !important;
}

.stick-top {
  top: 6em;
}

.vs-con-table ::v-deep .vs-table--tbody-table {
  min-width: 100%;
}

.vs-con-table {
  width: 100%;
}

.add-btn {
  color: #fff;
  background: $color;
  border-radius: 5em;
}

.skeleton {
  background: #808080;
  animation: flicker-light 1s infinite alternate;
}

@keyframes flicker-light {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.2;
  }
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content {
    width: 100%;
  }
}

.ps ::v-deep .ps__scrollbar-y-rail {
  z-index: 100;
}

.progress__container {
  background-color: rgba(255, 215, 97, 0.3);
  width: 100%;
  min-height: 13rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  text-align: left;

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 1.5rem;
    position: relative;

    img {
      width: 3rem;
      height: auto;
    }

    span {
      color: #ffb70c;
      // font-family: Poppins;
      font-size: 1rem;
      font-weight: 600;
      height: fit-content;
      position: absolute;
      margin-top: 5.5rem;
    }
  }

  &__bar {
    width: 100%;
    margin-right: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    height: 10rem;
    position: relative;

    img {
      width: 2rem;
      place-self: start;
    }

    .odd {
      place-self: start;
    }

    .even {
      place-self: end;
    }

    .progress {
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      border: none;
      border-radius: 10px;
      height: 15px;
      background-color: #fcde98;
      place-self: center;
      position: absolute;
      text-align: left;
    }

    /* For Chrome or Safari */
    progress::-webkit-progress-bar {
      background-color: #fcde98;
      border-radius: 10px;
    }

    progress::-webkit-progress-value {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }

    /* For Firefox */

    progress::-moz-progress-bar {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }
  }
}

@media screen and (max-width: 530px) {
  .notification {
    &__container {
      left: 0;
      width: 100%;
    }
  }
}
</style>
